import React, {useCallback} from 'react';

import {FormInput} from 'src/components/input';

import {CheckBox} from '@pb/kit-component-checkbox';
import {Group} from '@pb/kit-component-group';

import type {ProjectCodesFilters} from './constants';
import type {CheckBoxChangeData} from 'src/typedef';


type Props = {
    filter?: ProjectCodesFilters,
    onChange?: (filters: ProjectCodesFilters) => void,
};

export const ProjectCodesFiltersBody = ({filter, onChange}: Props) => {
    const changeName = useCallback((name: string) => {
        if (filter && onChange) {
            onChange({
                ...filter,
                name: name || undefined,
            });
        }
    }, [filter, onChange]);

    const changeActiveOnly = useCallback((changedData: CheckBoxChangeData) => {
        const activeOnly = changedData.event.currentTarget.checked;

        if (filter && onChange) {
            onChange({
                ...filter,
                activeOnly: activeOnly || undefined,
            });
        }
    }, [filter, onChange]);

    return (
        <Group direction="v">
            <FormInput
                label="Project Code"
                placeholder="Enter project code"
                width={250}
                value={filter?.name || ''}
                onBlur={changeName}
            />
            <CheckBox
                label="Show only active"
                checked={filter?.activeOnly}
                onCheckBoxChange={changeActiveOnly}
            />
        </Group>
    );
};
